import { signIn } from 'next-auth/react';
import {
  getLoginCorrelationId,
  runLoginRedirect,
} from 'shared-utils/unifiedLoginAnalytics';

// ULGOA-280/281: forwarded as an extra query param on the /oauth/authorize redirect so ue can
// capture it at the OAuth authorize step. Shared by both G2 login triggers -- the standard OIDC
// redirect (UserAuthDialog/hooks/useUserAuthDialog.js) and Google One Tap
// (OneTapScript/OneTapScript.js) -- since both call next-auth's signIn('g2', ...) and both need
// the same value captured the same way.

// The page the user was actually on when they initiated login, NOT the session's first-touch
// landing page (that's a different, already-tracked value -- see the landing_url cookie in
// middlewares/landingCookies.js / ClickoutWrapper/helpers.js -- and it does not change on
// internal navigation, so it cannot answer "where did this signin start"). Read fresh at call
// time; ue defaults to NULL rather than guessing when this is somehow unavailable.
//
// Deliberately not sending country here too: ue already resolves it server-side from the same
// cf-ipcountry header this page's own geoipDetector reads, on the very request this param rides
// on - sending it again would only add a path for a guessed fallback (this app's own default
// when the header is missing) to get persisted and Kafka-published as if it were real.
const getSigninUrl = () =>
  typeof window !== 'undefined' && window.location ? window.location.href : '';

export const getG2AuthorizationParams = (redirectLogin = true) => {
  const signinUrl = getSigninUrl();

  return {
    ...(signinUrl ? { signin_url: signinUrl } : {}),
    ...(redirectLogin
      ? { user_custom_session_id: getLoginCorrelationId() }
      : {}),
  };
};

export const redirectToG2 = (options) =>
  runLoginRedirect(async () => {
    await signIn('g2', options, getG2AuthorizationParams());
  });

// ULGOA-449: a stale-session 401 sends the still-signed-in user back through G2 to refresh the
// session. That is not a login, so login_intent=reauth tells ue not to record it as an sso
// login, and no login correlation UUID is sent.
export const reauthenticateWithG2 = (options) =>
  runLoginRedirect(async () => {
    await signIn('g2', options, {
      ...getG2AuthorizationParams(false),
      login_intent: 'reauth',
    });
  });
